import { render, staticRenderFns } from "./Organizer.vue?vue&type=template&id=533a3f3c&"
import script from "./Organizer.vue?vue&type=script&lang=js&"
export * from "./Organizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports